<template>
  <!--导入设置-->
  <div class="app-main-inner app-main-inner-row">
    <el-form label-width="100px" label-position="left" class="section" style="width: 650px;">
      <el-row :gutter="10">
        <el-col :span="24">
          <div style="display: flex">
            <div style="background-color: #57D1FF; width: 12px; height: 30px;margin-right: 5px;" />
            <label style="font-width: bold; font-size: 15px;">{{ $t('SeaExport.importSetting') }}</label>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.noRule')">
            <div style="display: flex; align-items: center;">
              <el-select
                v-model="noRule"
                no="1"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in noRuleList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-tooltip :content="$t('SeaExport.ImportChargeAllBusiness')" placement="top">
                <i class="el-icon-info" style="margin-left: 5px; font-size: 18px; cursor: pointer;" />
              </el-tooltip>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-checkbox-group v-model="selectedBusinessTypes" no="2">
            <el-checkbox label="SE">{{ $t('CargoMsg.Cargo_OceanExport') }}</el-checkbox>
            <el-checkbox label="SI">{{ $t('CargoMsg.Cargo_OceanImport') }}</el-checkbox>
            <el-checkbox label="AE">{{ $t('CargoMsg.Cargo_AirExport') }}</el-checkbox>
            <el-checkbox label="AI">{{ $t('CargoMsg.Cargo_AirImport') }}</el-checkbox>
            <el-checkbox label="RE">{{ $t('CargoMsg.Cargo_RailwayExport') }}</el-checkbox>
            <el-checkbox label="RI">{{ $t('CargoMsg.Cargo_RailwayImport') }}</el-checkbox>
            <el-checkbox label="IE">{{ $t('CargoMsg.Cargo_IntegratedJob') }}</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <!-- 导入文件-->
      <el-row :gutter="10">
        <el-col :span="24">
          <div style="display: flex">
            <div style="background-color: #57D1FF; width: 12px; height: 30px;margin-right: 5px" />
            <label style="font-width: bold; font-size: 15px;">{{ $t('SeaExport.importFile') }}</label>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.FileName')">
            <el-input ref="txtFileName" v-model="txtFileName" no="3" :readonly="true" />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <div style="flex: 1">
            <el-upload
              ref="upload"
              :data="{ uploadSetting: uploadSetting }"
              accept=".xls"
              :multiple="false"
              :action="URL.act.charge.importChargeAllBusiness"
              :headers="{sessionId, language}"
              :auto-upload="false"
              :show-file-list="false"
              :on-success="uploadExcelSuccess"
              :on-error="uploadExcelError"
              :on-change="handleChange"
              style="display: inline-block;"
            >
              <el-button type="primary" no="4">{{ $t('SeaExport.SelectFile') }}</el-button>
            </el-upload>

            <el-button type="primary" no="5" style="margin-left: 10px;" @click="downloadTemplate">{{ $t('SeaExport.TemplateDownload') }}</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.importExpenseStatus')">
            <el-select
              v-model="importExpenseStatus"
              no="6"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
              @change="importExpenseStatusChange($event)"
            >
              <el-option
                v-for="(item,index) in importExpenseStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.accountingDate')">
            <el-date-picker v-model="accountingDate" :disabled="!accountingDateShow" type="date" no="10" value-format="yyyy-MM-dd" style="width:195px;" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <div>
            <el-checkbox v-model="onlyImportedCurrentBranch" no="50">{{ $t('CargoMsg.Cargo_OnlyImportedCurrentBranch') }}</el-checkbox>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-button type="primary" no="7" @click="importFileBtnClickHandler">{{ $t('SeaExport.confirmImport') }}</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      v-if="importResultWindow.visible"
      v-el-drag-dialog
      :visible.sync="importResultWindow.visible"
      :title="importResultWindow.title"
      width="400px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="closeHandler"
    >
      <div style="display: flex;flex-direction: column; text-align: center">
        <span style="line-height: 40px;">{{ importResultWindow.content }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="8" style="margin-right: 30px;" @click="continueImporting()">{{ $t('SeaExport.ContinueImporting') }}</el-button>
        <el-button :disabled="!importResultWindow.downLoadDocumentId" type="primary" no="9" style="margin-right: 30px;" @click="downloadResultLog()">{{ $t('SeaExport.DownloadResultLog') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import $store from '@/store'

export default {
  name: 'BatchImportChargeAllBusiness',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  props: {
    lob: { type: String, required: true } // 业务类型
  },
  data() {
    return {
      URL,
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      uploadSetting: '',
      noRuleList: [
        { label: this.$t('Payment.businessNumber'), value: '0' },
        { label: this.$t('Payment.businessReferenceNumber') + '/' + this.$t('CargoMsg.Cargo_CustomerReferenceNumber'), value: '2' }
      ],
      noRule: '0', // 默认选中业务编号
      txtFileName: '', // 导入文件名
      selectedBusinessTypes: ['SE', 'SI', 'AE', 'AI', 'RE', 'RI', 'IE'], // 默认全选
      importResultWindow: {
        visible: false,
        downLoadDocumentId: '',
        title: '',
        content: ''
      },
      // 导入费用状态默认1：已提交  2：已审核 0：未提交
      importExpenseStatusList: [
        { label: this.$t('Message.Uncommitted'), value: '0' },
        { label: this.$t('Message.Submitted'), value: '1' },
        { label: this.$t('Message.Approved'), value: '2' }
      ],
      importExpenseStatus: '1', // 默认已提交
      accountingDate: '',
      accountingDateShow: true,
      onlyImportedCurrentBranch: false,
      loading: null
    }
  },
  computed: {
    language() {
      switch (this.$store.getters.language) {
        case 'zh':
          return 'zh_CN'
        case 'ja':
          return 'ja_JP'
        default:
          return 'en_US'
      }
    },
    sessionId() {
      return this.$store.getters.token
    }
  },
  watch: {},
  async created() {
    await cache.load(cacheName.CONFIG)
  },
  methods: {
    onShow() {
      this.uploadSetting = ''
      this.importResultWindow.downLoadDocumentId = ''
      this.initializeHandler()
    },
    // 从缓存里面加载导入设置
    initializeHandler() {
      const importSettingKey = 'IMPORTSETTING_AllBusiness'
      const setting = LocalStorageUtils.getConfiguration(importSettingKey)
      if (setting) {
        this.noRule = setting.noRule
        this.accountingDate = setting.accountingDate
        this.onlyImportedCurrentBranch = setting.onlyImportedCurrentBranch
        this.selectedBusinessTypes = setting.selectedBusinessTypes || ['SE', 'SI', 'AE', 'AI', 'RE', 'RI', 'IE']
        this.importExpenseStatus = setting.importExpenseStatus || '1'
        if (setting.importExpenseStatus === '0') {
          this.accountingDateShow = false
          this.accountingDate = ''
        }
      }
    },
    // 确认导入
    importFileBtnClickHandler() {
      this.loading = getLoading()
      // 验证导入设置必填
      if (!this.checkNotNull()) {
        this.loading.close()
        return
      }
      // 保存导入设置到缓存
      const setting = {}
      setting.noRule = this.noRule
      setting.selectedBusinessTypes = this.selectedBusinessTypes
      setting.importExpenseStatus = this.importExpenseStatus
      setting.branchId = $store.getters.currentOfficeId // 当前分公司ID
      setting.accountingDate = this.accountingDate
      setting.isFinance = true
      setting.onlyImportedCurrentBranch = this.onlyImportedCurrentBranch
      setting.canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))// 国内/国外
      setting.openSapConfig = parseInt(cache.config.get('openSapConfig'))// 是否开启SAP交单
      const importSettingKey = 'IMPORTSETTING_AllBusiness'
      LocalStorageUtils.setConfiguration(importSettingKey, setting)

      const uploadFiles = this.$refs.upload.uploadFiles
      if (uploadFiles && uploadFiles.length > 0 && setting) {
        const file = uploadFiles[uploadFiles.length - 1]
        setting.fileName = this.txtFileName
        setting.size = file.size
        if (this.txtFileName.indexOf('.') > -1) {
          const arr = this.txtFileName.split('.')
          setting.type = arr[arr.length - 1].toLowerCase()
        }
        setting.officeId = this.$store.getters.currentOfficeId
        setting.departId = this.$store.getters.currentDeptId
        this.uploadSetting = JSON.stringify(setting)
        setTimeout(() => {
          this.$refs.upload.submit()
        }, 1000)
      }
    },
    // 验证必填项
    checkNotNull() {
      if (this.noRule < 0) {
        this.$message.warning(this.$t('Message.numberingRuleCannotBeEmpty'))
        return false
      }
      if (!this.txtFileName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return false
      }
      if (this.selectedBusinessTypes.length === 0) {
        this.$message.warning('请至少选择一个业务类型')
        return false
      }
      if (this.importExpenseStatus === '2' && (this.accountingDate == null || this.accountingDate.length < 1)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FinancialDateCheckNull'))
        return false
      }
      var curDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      if (this.accountingDate > curDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FinancialDateCheckBefore'))
        return false
      }
      return true
    },
    // 导入成功
    uploadExcelSuccess(response, file, fileList) {
      if (this.loading) {
        this.loading.close()
      }
      const result = response.data
      const errors = response.errors || []
      if (!result && errors && errors.length > 0) {
        const errorMsg = errors[0].message
        this.$message.error(errorMsg)
        return
      }
      if (result) {
        if (result.message) {
          this.$confirm(result.message, this.$t('Message.Prompt'), { type: 'warning', closeOnClickModal: false, showCancelButton: false }).finally(() => {
            this.closeHandler()
          })
          return
        }
        if (result.rowNum && result.resultDocumentId) {
          const successNum = result.successNum
          this.importResultWindow.downLoadDocumentId = result.resultDocumentId
          this.importResultWindow.title = this.$t('SeaExport.ImportComplete')
          this.importResultWindow.content = successNum > 0 ? `${this.$t('Message.ImportSuccessful1')}` : `${this.$t('Message.ImportFailed')}`
          this.importResultWindow.visible = true
        } else {
          this.importResultWindow.downLoadDocumentId = ''
          this.importResultWindow.title = this.$t('Message.ImportFailed')
          this.importResultWindow.content = `${this.$t('CargoMsg.Cargo_UploadFailedCheckExcel')}`
          this.importResultWindow.visible = true
        }
      }
    },
    uploadExcelError() {
      if (this.loading) {
        this.loading.close()
      }
    },
    // 继续导入
    continueImporting() {
      this.closeHandler()
    },
    closeHandler() {
      this.$refs.upload.clearFiles()
      this.txtFileName = ''
      this.importResultWindow.visible = false
    },
    // 下载导入结果
    downloadResultLog() {
      this.closeHandler()
      // 从云存储上下载文件
      if (!this.importResultWindow.downLoadDocumentId) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      const url = `${URL.common.findByFileId}/${this.importResultWindow.downLoadDocumentId}?sessionId=${this.sessionId}`
      window.open(url)
    },
    handleChange(file, fileList) {
      if (fileList && fileList.length > 1) {
        // 清空所有文件
        this.$refs.upload.clearFiles()
        // 重新添加当前文件
        this.$refs.upload.handleStart(file.raw)
      }
      this.txtFileName = file.name || ''
    },
    // 下载模板
    downloadTemplate() {
      const office = $store.getters.currentOffice
      if (this.$store.getters.language === 'zh') {
        if (office && office.whtTaxMode) {
          ExportUtils.downloadTemplateFile('MonthCostTemplate-WHT.xls', 'chargeAllBusiness')
        } else {
          ExportUtils.downloadTemplateFile('MonthCostTemplate.xls', 'chargeAllBusiness')
        }
      } else {
        if (office && office.whtTaxMode) {
          ExportUtils.downloadTemplateFile('MonthCostTemplate(EN)-WHT.xls', 'chargeAllBusiness')
        } else {
          ExportUtils.downloadTemplateFile('MonthCostTemplate(EN).xls', 'chargeAllBusiness')
        }
      }
    },
    importExpenseStatusChange(value) {
      if (value === '0') {
        this.accountingDateShow = false
        this.accountingDate = ''
        return
      }
      this.accountingDateShow = true
    }
  }
}
</script>

<style scoped>

</style>
